import App from "../App";

import HeaderCart from "./HeaderCart";
import SwitchVAT from "./SwitchVAT";
import Search from "./Search";
import Categories from "../../Categories";
import UserMenu from "./UserMenu";

const HeaderMenu = () => {
  const hideToggleVat = location.pathname.includes("/confirmation");

  function isLoginPage() {
    const re = /.*\/login?\/$/;
    return re.test(window.location.pathname);
  }

  var showUserLogin = $("#SHOW_LOGIN").val().toLowerCase() === "true";
  React.useEffect(() => {
    new Categories().init();
  }, []);

  return (
    <>
      <a className="navbar-brand" href={$("#START_URL").val()}>
        <img className="logo" src={$("#LOGO_URL").val()} alt="" />
      </a>
      {!isLoginPage() ? (
        <>
          <div className="search-block d-flex flex-grow-1 col-12 col-lg py-2 py-lg-0">
            <button
              className="navbar-toggler border-0"
              id="js-categories-toggler"
              type="button"
              aria-label="Toggle navigation"
            >
              <div className="d-flex align-items-center justify-content-center">
                <svg className="icon icon--menu-bars " width="30" height="25">
                  <use
                    xlinkHref={`${$(
                      "#STATIC_ASSETS_URL"
                    ).val()}/images/sprites/symbol/sprite.svg#menu-bars`}
                  ></use>
                </svg>
              </div>
            </button>
            <div className="d-lg-flex flex-fill align-items-lg-center">
              <Search />
            </div>
          </div>
          <div className="d-flex align-items-center header-switch-block">
            {!hideToggleVat && <SwitchVAT />}
          </div>
          <div className="d-flex justify-content-around left-menu-block">
            {showUserLogin && <UserMenu />}
            <HeaderCart />
          </div>
        </>
      ) : null}
    </>
  );
};

export default (store, queryClient) => {
  const domContainer = document.getElementById("js-header-menu");
  if (domContainer) {
    const root = ReactDOMClient.createRoot(domContainer);

    root.render(
      <App store={store} queryClient={queryClient}>
        <HeaderMenu />
      </App>
    );
  }
};
